var map = {
	"./academicMenu.svg": "ur5s",
	"./account.svg": "lNpt",
	"./add.svg": "58n+",
	"./addRound.svg": "xelA",
	"./arrow-right.svg": "dxdv",
	"./arrowLeft.svg": "vdbd",
	"./arrowRight.svg": "/mtx",
	"./common-acupoint-list.svg": "M1Cm",
	"./delete-drug.svg": "DS+F",
	"./deleteGrey-1.svg": "1oCD",
	"./edit.svg": "ql+d",
	"./ellipsis.svg": "BT8c",
	"./export.svg": "gmuv",
	"./file.svg": "fQ0v",
	"./hospital.svg": "qfL7",
	"./icon-avatar.svg": "7Frk",
	"./icon-case.svg": "SJnU",
	"./icon-comments.svg": "Qwgv",
	"./icon-female.svg": "kUNx",
	"./icon-fullscreen.svg": "EaJv",
	"./icon-lingual.svg": "Iled",
	"./icon-male.svg": "5MGl",
	"./icon-medicalAdvice.svg": "B8tG",
	"./icon-patient.svg": "iCwW",
	"./icon-patientInfo.svg": "R6Cy",
	"./icon-prescription.svg": "klLC",
	"./icon-question.svg": "NF1I",
	"./icon-select.svg": "Vejl",
	"./icon-unfullScreen.svg": "29/1",
	"./iconMore.svg": "cwNI",
	"./medicalRecord.svg": "wTYy",
	"./menuActivity.svg": "fKbU",
	"./menuArticle.svg": "0to0",
	"./menuBusiness.svg": "ti6V",
	"./menuDocument.svg": "CMCD",
	"./menuHomeland.svg": "6ejr",
	"./menuOfficeCenter.svg": "+H3D",
	"./menuProjectCenter.svg": "zaR8",
	"./menuScience.svg": "BMdS",
	"./menuStatisticsCenter.svg": "zDVM",
	"./menuSystem.svg": "s9WO",
	"./menuWorkrepotSt.svg": "HBrw",
	"./noData.svg": "ew2i",
	"./one.svg": "0Vh/",
	"./password.svg": "QjmH",
	"./prescription.svg": "69aL",
	"./promote.svg": "kM8W",
	"./provincial-template-empty.svg": "9M4n",
	"./sft-icon1.svg": "IeJ6",
	"./sft-icon2.svg": "aWkX",
	"./sft-icon3.svg": "p3e5",
	"./sft-icon4.svg": "k66U",
	"./staroff.svg": "PHuH",
	"./staron.svg": "uaQX",
	"./subsnum.svg": "ab7Z",
	"./substotal.svg": "vg61",
	"./three.svg": "vW8z",
	"./tplManage.svg": "gCCg",
	"./two.svg": "sNM8",
	"./workflow.svg": "BbxN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 111